import { Button, Table, TableColumnsType } from "antd";
import { convertIosStringToDate2, formatToCurrencyType } from "helper/common";
import React, { useEffect, useState } from "react";
import { components } from "./EditTable";
import { ListActionButton, Notification } from "components/common";
import { inpatientService } from "api";
import { arabToRoman } from "roman-numbers";
import { columnsTabPay } from "pages/Pay/PayTab/PayDetailTab/TabPay/TabPayColumn.config";

const ListAssignModal = (props) => {
  const { listAssign, setListAssign, setDichVus, idToDieuTri } = props;
  let columnsTable: any = [
    {
      title: "STT",
      key: "stt",
      dataIndex: "stt",
      render: (v, r, i) => {
        if (r?.maDichVu) {
          return <div style={{ textAlign: "center" }}>{i + 1}</div>;
        } else {
          return arabToRoman(v);
        }
      },
    },
    {
      title: "Mã dịch vụ",
      key: "maDichVu",
      align: "center",
      dataIndex: "maDichVu",
    },
    {
      title: "Tên dịch vụ",
      key: "tenChiDinh",
      align: "left",
      dataIndex: "tenChiDinh",
    },
    {
      title: "Đơn giá",
      key: "donGia",
      align: "right",
      dataIndex: "donGia",
      render: (v, r, i) => (v ? formatToCurrencyType(v) : <></>),
    },
    {
      title: "Đơn giá BHYT",
      key: "baoHiemTra",
      align: "right",
      dataIndex: "baoHiemTra",
      render: (v, r, i) => {
        if (v) {
          return <>{formatToCurrencyType(v)}</>;
        } else {
          return <></>;
        }
      },
    },
    {
      title: "Ngày chỉ định",
      key: "thoiGian",
      align: "center",
      dataIndex: "thoiGian",
      onCell: (record: any) => {
        return {
          record,
          dataIndex: "thoiGian",
          handleSave,
        };
      },
    },
    // {
    //   title: "Tư vấn",
    //   key: "canTuVan",
    //   align: "center",
    //   dataIndex: "canTuVan",
    //   render: (v, r, i) => {
    //     return <div>{v ? "Có" : "Không"}</div>;
    //   },
    // },
    // {
    //   title: "Trạng thái TT",
    //   key: "trangThaiThanhToan",
    //   align: "center",
    //   dataIndex: "trangThaiThanhToan",
    // },
    // {
    //   title: "Trạng thái HĐ",
    //   key: "trangThai",
    //   align: "center",
    //   dataIndex: "trangThai",
    // },
    {
      title: "Số lượng",
      key: "soLuong",
      align: "center",
      dataIndex: "soLuong",
    },
    {
      title: "Ghi chú",
      key: "ghiChu",
      align: "center",
      dataIndex: "ghiChu",
    },
    {
      title: "Thao tác",
      key: "action",
      align: "center",
      dataIndex: "action",
    },
  ];
  const [data, setData] = useState([]);
  // console.log("🚀 ~ ListAssignModal ~ data:", data);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const expandAllRows = () => {
    const keys = [];
    const expandKeys = (data) => {
      data?.forEach((item) => {
        keys.push(item?.key);
        if (item?.children) {
          expandKeys(item?.children);
        }
      });
    };
    expandKeys(data);
    setExpandedRowKeys(keys);
  };

  const getChiDinh = (data) => {
    let res = [];
    data?.nhomChiDinhDtos?.map((et) => {
      res = [...res, ...(et?.chiDinhDtos ?? [])];
    });
    return res;
  };
  // const expandableRowRender = (record, idx, indent, expanded) => {

  //   return <Table components={components} columns={_expand_columns} dataSource={getChiDinh(record)??[]} bordered pagination={false}/>
  // }
  const updateThoiGianChiDinh = async (params) => {
    try {
      await inpatientService.updateThoiGianChiDinh(params);
      Notification("success", "Cập nhật thời gian chỉ định thành công");
      getListAssign(idToDieuTri);
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };
  const getListAssign = async (idToDieuTri) => {
    try {
      const toDieuTri = await inpatientService.getToDieuTri(idToDieuTri);

      setListAssign(toDieuTri?.phieuChiDinhDtos ?? []);
      setDichVus(toDieuTri?.phieuChiDinhDtos ?? []);
    } catch (error) {}
  };

  //Xoá 1 chỉ định
  const deleteChiDinh = async (id) => {
    try {
      const res = await inpatientService.deleteChiDinh(id);
      getListAssign(idToDieuTri);

      Notification("success", "Đã xóa chỉ định");
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };
  // Xoá cả mục chỉ định
  const deletePhieuChiDinh = async (id) => {
    try {
      await inpatientService.deletePhieuChiDinh(id);
      getListAssign(idToDieuTri);
      Notification("success", "Đã xóa phiếu chỉ định");
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };
  useEffect(() => {
    expandAllRows();
  }, [props, data]);
  useEffect(() => {
    const dataTable = listAssign?.map((item, index) => {
      return {
        key: item?.id,
        tenChiDinh: "",
        maDichVu: "",
        stt: index + 1,
        thoiGian: item.ngayTaoPhieu,
        children: item?.nhomChiDinhDtos?.map((e, idx) => {
          return {
            key: `${item?.id}-${idx}`,
            tenChiDinh: e?.tenNhomChiDinh,
            thoiGian: "",
            children: e?.chiDinhDtos?.map((i) => {
              return {
                ...i,
                key: i.id,
              };
            }),
          };
        }),
      };
    });
    setData(dataTable);
  }, [props, listAssign]);
  const handleSave = (row: any) => {
    const dataTable = listAssign?.map((item, index) => {
      return {
        key: item?.id,
        tenChiDinh: "",
        maDichVu: "",
        stt: index + 1,
        thoiGian: index + 1 == row.stt ? row.thoiGian : item.ngayTaoPhieu,
        children: item?.nhomChiDinhDtos?.map((e, idx) => {
          return {
            key: `${item?.id}${idx}`,
            tenChiDinh: e?.tenNhomChiDinh,
            thoiGian: "",
            children: e?.chiDinhDtos?.map((i) => {
              return {
                ...i,
                key: i.id,
              };
            }),
          };
        }),
      };
    });
    setData(dataTable);
  };
  columnsTable.map((record) => {
    if (record.dataIndex == "tenChiDinh") {
      record.render = (text, record: any, index) => {
        const isParent = record.children;
        if (isParent) {
          return (
            <span
              style={
                isParent
                  ? { fontWeight: "bold", textDecoration: "underline" }
                  : {}
              }
            >
              {text}
            </span>
          );
        } else {
          return <div style={{ paddingLeft: "15px" }}>{text}</div>;
        }
      };
    }
    if (record.dataIndex == "action") {
      record.render = (v, r, i) => {
        return !r.tenChiDinh ? (
          <ListActionButton
            toolTipSave={"Cập nhật thời gian chỉ định"}
            saveFunction={() => {
              const params = { id: r?.key, thoiGian: r?.thoiGian };
              updateThoiGianChiDinh(params);
              // call api luu thông tin lô
            }}
            deleteFunction={() => {
              deletePhieuChiDinh(r?.key);
            }}
          ></ListActionButton>
        ) : r?.maDichVu ? (
          <ListActionButton
            toolTipSave={"Xoá chỉ định"}
            // saveFunction={() => {
            //   const params = { id: r?.id, thoiGian: r?.thoiGian };
            //   updateThoiGianChiDinh(params);
            //   // call api luu thông tin lô
            // }}
            deleteFunction={() => {
              deleteChiDinh(r?.id);
              // setOptions(options.filter((e) => e.id != r.id));
            }}
          ></ListActionButton>
        ) : (
          <></>
        );
      };
    }
  });
  return (
    <div>
      <Table
        components={components}
        // rowKey={record => record.id}
        dataSource={data}
        columns={columnsTable}
        pagination={false}
        // expandable={{expandedRowRender: expandableRowRender, defaultExpandedRowKeys: []}}
        defaultExpandAllRows={true}
        expandedRowKeys={expandedRowKeys}
        expandable={{
          expandIcon: () => null,
          defaultExpandedRowKeys: [],
        }}
        bordered
      ></Table>
    </div>
  );
};
export default ListAssignModal;
